export default "__VITE_ASSET__IJQVE8t1__"